import {KTUtil} from '../components/base/util.js';
import {KTOffcanvas} from '../components/base/offcanvas.js';
import {KTMenu} from '../components/base/menu.js';
import {KTScrolltop} from "../components/base/scrolltop.js";

export const KTLayout = function () {
    let body;
    let aside;

    const initAside = function () {
        aside = KTUtil.get('kt_aside');

        // Init offcanvas layout for mobile
        new KTOffcanvas('kt_aside', {
            baseClass: 'kt-aside',
            overlay: true,
            closeBy: 'kt_aside_close_btn',
            toggleBy: {
                target: 'kt_aside_mobile_toggler',
                state: 'kt-header-mobile__toolbar-toggler--active'
            }
        });

        // Init aside menu
        const menu = KTUtil.getByID('kt_aside_menu');
        const menuDesktopMode = (KTUtil.attr(menu, 'data-ktmenu-dropdown') === '1' ? 'dropdown' : 'accordion');


        // Init aside menu
        new KTMenu('kt_aside_menu', {
            // submenu setup
            submenu: {
                desktop: {
                    // by default the menu mode set to accordion in desktop mode
                    default: menuDesktopMode,
                    // whenever body has this class switch the menu mode to dropdown
                    state: {
                        body: 'kt-aside--minimize',
                        mode: 'dropdown'
                    }
                },
                tablet: 'accordion', // menu set to accordion in tablet mode
                mobile: 'accordion' // menu set to accordion in mobile mode
            },

            //accordion setup
            accordion: {
                expandAll: false // allow having multiple expanded accordions in the menu
            }
        });
    };

    const initScrolltop = function () {
        new KTScrolltop('kt_scrolltop', {
            offset: 300,
            speed: 600
        });
    };

    return {
        init: function () {
            body = KTUtil.getByTag('body');

            this.initAside();
            this.initScrolltop();
        },

        initAside: function () {
            initAside();
        },

        initScrolltop: function () {
            initScrolltop();
        }
    };
}();

export {}
